import React, { useState, useEffect } from 'react';
import SeoHelmet from '../components/SeoHelmet';

// SVG Icons
const Icons = {
  Distribution: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
    </svg>
  ),
  Publishing: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  ),
  Marketing: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
    </svg>
  ),
  Advisory: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895.356-1.754.988-2.386l-.548-.547z" />
    </svg>
  ),
  Branding: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Sync: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Booking: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
    </svg>
  ),
  Expertise: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
    </svg>
  ),
  Producers: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
    </svg>
  ),
  Connections: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  Versatility: () => (
    <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
  )
};

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeService, setActiveService] = useState('distribution');

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const services = {
    distribution: {
      title: 'Distribution',
      description: 'At Hi-Way 89, we ensure your music reaches every corner of the globe.',
      details: `We distribute your tracks to all major digital streaming platforms—including Spotify, Apple Music, Amazon Music, TikTok, YouTube Music, and 200+ other platforms worldwide. We also ensure that your royalties are tracked and paid on time.`,
      benefits: [
        'Global distribution to 200+ platforms',
        'Optimized metadata for maximum discoverability',
        'Transparent royalty tracking and timely payments',
        'Strategic release planning',
        'Priority playlist pitching'
      ],
      Icon: Icons.Distribution
    },
    publishing: {
      title: 'Publishing',
      description: 'We handle the complex publishing side so you can focus on creating.',
      details: `At Hi-Way 89, we understand that the publishing side of music can be complex, and so we save you the stress and handle it for you. We ensure that your intellectual property is protected and you receive all royalties from performances, sales and placements.`,
      benefits: [
        'Global copyright registration and protection',
        'Mechanical royalty collection',
        'Performance royalty tracking',
        'Publishing administration across all territories'
      ],
      Icon: Icons.Publishing
    },
    marketing: {
      title: 'Marketing',
      description: 'Cut through the noise with tailored marketing strategies.',
      details: `At Hi-Way 89, we help artists cut through the noise. Our marketing strategies are tailored to each artist's unique sound and goals. From social media campaigns and content creation to digital advertising and audience engagement.`,
      benefits: [
        'Tailored marketing strategies',
        'Social media management and content creation',
        'Digital advertising campaigns (Meta, Google, TikTok)',
        'Audience analytics and growth strategies',
        'Press releases and media outreach',
        'Influencer partnerships'
      ],
      Icon: Icons.Marketing
    },
    advisory: {
      title: 'Music Advisory',
      description: 'Strategic guidance for every stage of your career.',
      details: `Here at Hi-Way 89, we understand the sensitivity of decision-making for artists at different stages of their careers. So we provide consultations and guidance that help them make informed decisions.`,
      benefits: [
        'Career strategy consultation',
        'Contract review and negotiation support',
        'Release strategy planning',
        'A&R guidance',
        'Industry connection facilitation',
        'Long-term career roadmapping'
      ],
      Icon: Icons.Advisory
    },
    branding: {
      title: 'Brand Partnerships',
      description: 'Connect with brands that align with your values and amplify your reach.',
      details: `At Hi-Way 89, we understand that brand partnerships are not about the money but about building the right portfolio and reaching a win-win collaboration. This is why we ensure that artists connect with the right brands.`,
      benefits: [
        'Brand partnership opportunities',
        'Endorsement deal negotiations',
        'Sponsored tour support',
        'Product collaboration opportunities',
        'Long-term brand ambassadorships'
      ],
      Icon: Icons.Branding
    },
    sync: {
      title: 'Sync Placements',
      description: 'Place your music in TV shows, films, commercials, and more.',
      details: `One well-placed sync can change everything, from generating significant income and exposure to literally transforming your career overnight. That is why we constantly pursue sync opportunities your sound aligns with.`,
      benefits: [
        'Active pitching to music supervisors',
        'TV, film, and commercial placements',
        'Video game licensing opportunities',
        'Podcast and digital content sync',
        'Full rights clearance handling'
      ],
      Icon: Icons.Sync
    },
    booking: {
      title: 'Booking & Touring',
      description: 'Take your music from streaming platforms to live stages.',
      details: `At Hi-Way 89, we help artists take their music from streaming platforms to live stages. Our booking team secures performance opportunities ranging from intimate shows to major stages across Canada and Africa.`,
      benefits: [
        'Live show bookings',
        'Tour routing and planning',
        'Performance fee negotiations',
        'International touring support',
        'Tour logistics and rider management'
      ],
      Icon: Icons.Booking
    }
  };

  const whyChooseUs = [
    {
      title: 'Industry Expertise',
      description: 'We have over a decade of combined experience in artist development in Canada and Africa. We have seen what works and what doesn\'t.',
      Icon: Icons.Expertise
    },
    {
      title: 'Award-winning Producers',
      description: 'We have a team of producers and collaborators who are industry heavyweights and who have worked with global stars.',
      Icon: Icons.Producers
    },
    {
      title: 'Cross-Continental Connections',
      description: 'We\'re uniquely positioned as the bridge between Canadian and African music industries.',
      Icon: Icons.Connections
    },
    {
      title: 'Genre Fusion & Versatility',
      description: 'We work with artists across the full spectrum of music, from Afrobeats and amapiano to hip-hop, R&B, and pop.',
      Icon: Icons.Versatility
    }
  ];

  const howItWorks = [
    {
      step: '01',
      title: 'Get in Touch',
      description: 'Reach out to us through any of our contact details provided.'
    },
    {
      step: '02',
      title: 'Initial Consultation',
      description: 'Schedule a consultation to discuss your specific needs and create a tailored plan.'
    },
    {
      step: '03',
      title: 'Customised Service Plan',
      description: 'We\'ll develop a package that makes sense for where you are and where you want to be.'
    },
    {
      step: '04',
      title: 'Onboarding',
      description: 'We\'ll onboard you into our systems and develop your release strategy.'
    },
    {
      step: '05',
      title: 'Execution',
      description: 'Full throttle execution on set plans and strategy.'
    }
  ];

  const metadata = {
    title: 'Services | HI-WAY 89 - Music Label Services',
    description: 'Global music distribution, marketing, publishing, sync placements, and artist development services. Bridge between Canadian and African music industries.',
    canonical: "/services"
  };

  const handleContactClick = () => {
    document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <SeoHelmet {...metadata} />

      <div className="min-h-screen bg-black text-white pt-28">
        {/* Hero Section */}
        <div className={`relative overflow-hidden transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="container mx-auto px-6 py-12 md:py-24">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-black mb-6 tracking-tighter leading-tight">
                <span className="block">TALENT ISN'T</span>
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">THE PROBLEM.</span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed">
                You've got the music. You've got the drive. What you don't have is someone who can get your song on that playlist, book you on that big stage, or connect you with that producer who could change everything.
              </p>
              <button
                onClick={handleContactClick}
                className="group relative px-12 py-4 bg-white text-black font-bold text-lg tracking-widest overflow-hidden transition-all duration-300 hover:bg-gray-100 transform hover:scale-105"
              >
                <span className="relative z-10">READY TO WORK WITH US?</span>
                <div className="absolute inset-0 bg-gradient-to-r from-gray-200 to-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>
            </div>
          </div>
          
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black pointer-events-none"></div>
        </div>

        {/* What We Offer Section */}
        <div className="container mx-auto px-6 py-20">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">WHAT WE OFFER</span>
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                We don't just sign artists; we give you the infrastructure to build a career that crosses borders.
              </p>
            </div>

            {/* Services Navigation */}
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              {Object.keys(services).map((serviceKey) => (
                <button
                  key={serviceKey}
                  onClick={() => setActiveService(serviceKey)}
                  className={`px-6 py-3 font-medium text-sm tracking-widest transition-all duration-300 relative group ${
                    activeService === serviceKey
                      ? 'text-white bg-white/10'
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <span className="relative z-10">{services[serviceKey].title}</span>
                  {activeService === serviceKey && (
                    <div className="absolute inset-0 border border-white/20"></div>
                  )}
                </button>
              ))}
            </div>

            {/* Active Service Details */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-24">
              <div className="space-y-8">
                <div className="flex items-center space-x-4">
                  <div className="text-gray-400 group-hover:text-white transition-colors duration-300">
                    {React.createElement(services[activeService].Icon)}
                  </div>
                  <div>
                    <h3 className="text-3xl font-black mb-2">{services[activeService].title}</h3>
                    <p className="text-xl text-gray-300">{services[activeService].description}</p>
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed text-lg">
                  {services[activeService].details}
                </p>
              </div>
              
              <div className="space-y-6">
                <h4 className="text-2xl font-bold border-l-4 border-white pl-4">WHAT YOU GET:</h4>
                <div className="grid gap-4">
                  {services[activeService].benefits.map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-3 group cursor-pointer">
                      <div className="w-2 h-2 bg-white rounded-full mt-2 group-hover:scale-125 transition-transform duration-300"></div>
                      <span className="text-gray-300 group-hover:text-white transition-colors duration-300">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Why Choose Us */}
            <div className="mb-24">
              <h2 className="text-4xl md:text-5xl font-black mb-12 text-center tracking-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">WHY CHOOSE US</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {whyChooseUs.map((item, index) => (
                  <div key={index} className="group p-6 border border-gray-800 hover:border-white/30 transition-all duration-500 hover:bg-white/5">
                    <div className="text-gray-400 group-hover:text-white mb-4 transition-colors duration-300">
                      {React.createElement(item.Icon)}
                    </div>
                    <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                    <p className="text-gray-300 text-sm leading-relaxed">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* How It Works */}
            <div className="mb-24">
              <h2 className="text-4xl md:text-5xl font-black mb-12 text-center tracking-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">HOW IT WORKS</span>
              </h2>
              <div className="relative">
                {/* Timeline Line */}
                <div className="absolute left-4 md:left-1/2 md:-translate-x-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-white via-white/50 to-transparent hidden md:block"></div>
                
                <div className="space-y-12">
                  {howItWorks.map((step, index) => (
                    <div key={index} className={`relative flex flex-col md:flex-row items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      {/* Step Number */}
                      <div className="relative z-10 w-24 h-24 flex items-center justify-center mb-6 md:mb-0">
                        <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-white/5 rounded-full transform rotate-45"></div>
                        <span className="text-3xl font-black relative z-10">{step.step}</span>
                      </div>
                      
                      {/* Content */}
                      <div className={`flex-1 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12'} text-center md:text-left`}>
                        <div className="max-w-md mx-auto md:mx-0">
                          <h3 className="text-2xl font-bold mb-3">{step.title}</h3>
                          <p className="text-gray-300">{step.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* CTA Section */}
            <div className="text-center py-16 border-t border-b border-gray-800 mb-24">
              <h2 className="text-4xl md:text-5xl font-black mb-6 tracking-tight">
                READY TO TAKE YOUR MUSIC CAREER GLOBAL?
              </h2>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                Whether you're an emerging artist grinding for your first break or an established act ready to go international.
              </p>
              <button
                onClick={handleContactClick}
                className="group relative px-12 py-4 bg-gradient-to-r from-white to-gray-200 text-black font-bold text-lg tracking-widest overflow-hidden transition-all duration-300 hover:from-gray-200 hover:to-white transform hover:scale-105"
              >
                <span className="relative z-10">LET'S TALK</span>
                <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>
            </div>

            {/* Contact Section */}
            <div id="contact-section" className="pb-24">
              <h2 className="text-4xl md:text-5xl font-black mb-12 text-center tracking-tight">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">GET IN TOUCH</span>
              </h2>
              
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
                {/* Contact Form */}
                <div className="space-y-8">
                  <div>
                    <h3 className="text-2xl font-bold mb-6">SEND US A MESSAGE</h3>
                    <form className="space-y-6">
                      <div>
                        <input
                          type="text"
                          placeholder="Your Name"
                          className="w-full px-4 py-3 bg-white/5 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-all duration-300"
                        />
                      </div>
                      <div>
                        <input
                          type="email"
                          placeholder="Your Email"
                          className="w-full px-4 py-3 bg-white/5 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-all duration-300"
                        />
                      </div>
                      <div>
                        <select className="w-full px-4 py-3 bg-white/5 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-all duration-300">
                          <option value="">I'm interested in...</option>
                          <option value="distribution">Distribution</option>
                          <option value="marketing">Marketing</option>
                          <option value="publishing">Publishing</option>
                          <option value="advisory">Music Advisory</option>
                          <option value="branding">Brand Partnerships</option>
                          <option value="sync">Sync Placements</option>
                          <option value="booking">Booking & Touring</option>
                          <option value="full">Full Label Services</option>
                        </select>
                      </div>
                      <div>
                        <textarea
                          placeholder="Tell us about your project or needs..."
                          rows="4"
                          className="w-full px-4 py-3 bg-white/5 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:border-white transition-all duration-300 resize-none"
                        ></textarea>
                      </div>
                      <button
                        type="submit"
                        className="w-full px-8 py-4 bg-white text-black font-bold text-sm tracking-widest hover:bg-gray-100 transition-all duration-300 transform hover:scale-105"
                      >
                        SEND MESSAGE
                      </button>
                    </form>
                  </div>
                </div>

                {/* Contact Info */}
                <div className="space-y-8">
                  <div>
                    <h3 className="text-2xl font-bold mb-6">CONTACT DETAILS</h3>
                    <div className="space-y-6">
                      <div className="flex items-start space-x-4">
                        <svg className="w-6 h-6 text-gray-400 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <div>
                          <p className="text-sm text-gray-400 mb-1">EMAIL</p>
                          <p className="text-lg">info@hiway89.com</p>
                        </div>
                      </div>
                      
                      <div className="flex items-start space-x-4">
                        <svg className="w-6 h-6 text-gray-400 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <div>
                          <p className="text-sm text-gray-400 mb-1">LOCATIONS</p>
                          <p className="text-lg">Toronto, Canada</p>
                          <p className="text-lg">Lagos, Nigeria</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-2xl font-bold mb-6">FOLLOW US</h3>
                    <div className="flex space-x-6">
                      {['instagram', 'twitter', 'tiktok', 'youtube'].map((platform) => (
                        <a
                          key={platform}
                          href="#"
                          className="w-12 h-12 flex items-center justify-center border border-gray-700 text-gray-400 hover:text-white hover:border-white transition-all duration-300 transform hover:scale-110"
                          aria-label={platform}
                        >
                          <span className="text-lg font-medium">{platform.charAt(0).toUpperCase()}</span>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;